import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
/**
 * Button component — accessible, touch-friendly (min 44x44px).
 */
export const Button = forwardRef(({ variant = 'primary', size = 'md', loading, fullWidth, children, disabled, className = '', ...props }, ref) => {
    const classes = [
        'ipsoft-btn',
        `ipsoft-btn-${variant}`,
        `ipsoft-btn-${size}`,
        fullWidth ? 'ipsoft-btn-full' : '',
        loading ? 'ipsoft-btn-loading' : '',
        className,
    ].filter(Boolean).join(' ');
    return (_jsxs("button", { ref: ref, className: classes, disabled: disabled || loading, "aria-busy": loading, ...props, children: [loading && _jsx("span", { className: "ipsoft-btn-spinner", "aria-hidden": "true", children: "\u2699" }), children] }));
});
Button.displayName = 'Button';
//# sourceMappingURL=Button.js.map